const WEBCHECKIN = 'AGWebCheckIn'
const USERINFO = 'AGUserInfo'
const SESSION = 'AGSession'
const IDENTIFIER = 'AGIdentifier'
const TERMSOFSERVICE = 'AGTermsOfService'
const PRIVACYPOLICY = 'AGPrivacyPolicy'
const RESTCOUNTRIES = 'AGCountries'
const PHONENUMBER = 'AGPhoneNumber'
const COUNTRYCODE = 'AGCountryCode'
const SUPPORTDATA = 'AGSUPPORTDATA'
const USERINFORMATION = 'AGUserInformation'
const BOOKING = 'AGbooking'
const TOKENCODE = 'AGTokenCode'
const storage = sessionStorage

const store = {
  saveTokenCode (item: string) {
    storage.setItem(TOKENCODE, JSON.stringify(item))
  },
  getTokenCode () {
    const s = storage.getItem(TOKENCODE)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveBookingId (id: string) {
    storage.setItem(BOOKING, id)
  },
  getBookingId () {
    return storage.getItem(BOOKING)
  },
  getUserInformation () {
    const s = storage.getItem(USERINFORMATION)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  removeLocalstorage (item: any) {
    storage.removeItem(item)
  },
  getHotelInfo () {
    const s = storage.getItem(WEBCHECKIN)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveHotelInfo (content: any) {
    storage.setItem(WEBCHECKIN, JSON.stringify(content))
  },
  getUserInfo () {
    const s = storage.getItem(USERINFO)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveUserInfo (info: any) {
    storage.setItem(USERINFO, JSON.stringify(info))
  },
  getToken () {
    return storage.getItem(SESSION)
  },
  saveToken (token: any) {
    storage.setItem(SESSION, token)
  },
  saveSupportData (supportData: any) {
    storage.setItem(SUPPORTDATA, JSON.stringify(supportData))
  },
  getSupportData () {
    const s = storage.getItem(SUPPORTDATA)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  getIdentifier () {
    const s = storage.getItem(IDENTIFIER)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveIdentifier (identifier: any) {
    storage.setItem(IDENTIFIER, JSON.stringify(identifier))
  },
  getToSVersion () {
    const s = storage.getItem(TERMSOFSERVICE)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveToSVersion (version: any) {
    storage.setItem(TERMSOFSERVICE, JSON.stringify(version))
  },
  getPPVersion () {
    const s = storage.getItem(PRIVACYPOLICY)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  savePPVersion (version: any) {
    storage.setItem(PRIVACYPOLICY, JSON.stringify(version))
  },
  getRESTCountries () {
    const s = storage.getItem(RESTCOUNTRIES)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveRESTCountries (countries: any) {
    storage.setItem(RESTCOUNTRIES, JSON.stringify(countries))
  },
  getPhoneNumber () {
    const s = storage.getItem(PHONENUMBER)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  savePhoneNumber (phoneNumber: any) {
    storage.setItem(PHONENUMBER, JSON.stringify(phoneNumber))
  },
  getCountryCode () {
    const s = storage.getItem(COUNTRYCODE)
    if (s == null) { return null }
    return JSON.parse(s)
  },
  saveCountryCode (countryCode: any) {
    storage.setItem(COUNTRYCODE, JSON.stringify(countryCode))
  }
}
export default store
